<p><strong>I TUOI ABBONAMENTI:</strong></p>

<div class="accordian fusion-accordian" style="margin-bottom: 5%">
  <div class="panel-group" id="accordion-disclaimer" role="tablist">
    <div class="fusion-panel panel-default fusion-toggle-no-divider" role="tabpanel">
      <div class="panel-heading">
        <div>
          <h4 class="panel-title toggle">
            <a aria-expanded="false" aria-selected="false" aria-controls="#disclaimer" role="tab" data-toggle="collapse"
              data-parent="#accordion-disclaimer" data-target="#disclaimer" href="#disclaimer"><span
                class="fusion-toggle-icon-wrapper" aria-hidden="true"><i class="fa-fusion-box"></i></span><span
                class="fusion-toggle-heading" style="font-weight: 600; color: #333333">INFORMAZIONI
                IMPORTANTI</span></a>
          </h4>
        </div>
        <div id="disclaimer" class="panel-collapse collapse">
          <style>
            ol.letter,
            ol.number {
              counter-reset: list;
              margin: 10px 0 10px 0;
            }

            ol.letter>li,
            ol.number>li {
              list-style: none;
              font-size: 15px;
              color: #333333;
              font-weight: 400;
              margin-top: 10px;
            }

            ol.letter>li:before {
              counter-increment: list;
              content: counter(list, lower-alpha) ") ";
            }

            ol.number>li:before {
              content: counter(list) ") ";
              counter-increment: list;
            }

            span.column-name {
              border: 1px solid #333333;
              margin-right: 5px;
              padding: 0 2px;
              font-size: 14px;
            }
          </style>
          <div class="panel-body toggle-content fusion-clearfix">
            <h5>
              La segnalazione da parte degli utenti (tramite la funzione
              "segnala un Abuso") di un uso improprio della funzione "CREA
              GARA", utilizzata solo come indagine di mercato per comparare i
              prezzi senza la volontà effettiva di ricercare l’appaltatore, se
              ripetutamente perpetrata nel tempo, determinerà (dopo le opportune
              verifiche) la rimozione dei crediti residui.
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="profile.privateRegistry">
  <h5 *ngIf="profile.prepaidCredits.amount">
    ABBONAMENTO DI {{ profile.prepaidCredits.amount }} GARE ACQUISTATO IN DATA
    {{ profile.prepaidCredits.purchaseDate }} &#8211; (<strong>SCAD. {{ profile.prepaidCredits.expirationDate
      }}</strong>)
  </h5>
  <div class="fusion-sep-clear"></div>
  <div class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
  <h3 *ngIf="profile.prepaidCredits.amount" style="text-align: center">
    {{ profile.prepaidCredits.remaining }}
    {{
    profile.prepaidCredits.remaining === 1 ? "GARA RESIDUA" : "GARE RESIDUE"
    }}
  </h3>
  <h3 *ngIf="profile.prepaidCredits.amount === null" style="text-align: center">
    Nessun acquisto effettuato
  </h3>
  <div *ngIf="!profile.prepaidCredits.professionalRegistrySubscriber" class="fusion-sep-clear"></div>
  <div *ngIf="!profile.prepaidCredits.professionalRegistrySubscriber"
    class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
  <h5 *ngIf="creditExpired" style="margin-top: 4vh">
    Acquista un nuovo abbonamento per rendere di nuovo utilizzabili i crediti
    scaduti.
  </h5>
  <div class="fusion-sep-clear"></div>
  <div class="fusion-separator fusion-full-width-sep sep-none"
    style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
  <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
    <div class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-42
        fusion-one-half
        fusion-column-first
        1_2
      " style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4%) * 0.5));
        margin-right: 4%;
      ">
      <div class="fusion-column-wrapper fusion-column-wrapper-42" style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        " data-bg-url="">
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-36 {
              border-radius: 0px;
            }
          </style><a [routerLink]="['/richiestapreventivo']" class="
              fusion-button
              button-flat
              fusion-button-default-size
              button-default button-36
              fusion-button-span-yes fusion-button-default-type
            " target="_self"><span class="fusion-button-text">CREA GARA</span></a>
        </div>
      </div>
    </div>
    <div class="
        fusion-layout-column
        fusion_builder_column
        fusion_builder_column_1_2
        fusion-builder-nested-column-43
        fusion-one-half
        fusion-column-last
        1_2
      " style="
        margin-top: 0px;
        margin-bottom: 0px;
        width: 50%;
        width: calc(50% - ((4%) * 0.5));
      ">
      <div class="fusion-column-wrapper fusion-column-wrapper-43" style="
          padding: 0px 0px 0px 0px;
          background-position: left top;
          background-repeat: no-repeat;
          -webkit-background-size: cover;
          -moz-background-size: cover;
          -o-background-size: cover;
          background-size: cover;
        " data-bg-url="">
        <div style="font-size: 12px; color: black">
          UTILIZZATO da:<br />
          - Professionisti o Committenti per CREARE gare d’appalto<br />
          - Imprese per CREARE gare di subappalto<br /><br />
        </div>
        <div class="fusion-button-wrapper fusion-align-block">
          <style type="text/css">
            .fusion-button.button-37 {
              border-radius: 0px;
            }
          </style><a (click)="buyTenderPrepaidPacket()" class="
              fusion-button
              button-flat
              fusion-button-default-size
              button-default button-37
              fusion-button-span-yes fusion-button-default-type
            " target="_self"><span class="fusion-button-text">ACQUISTA ABBONAMENTO</span></a>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!profile.privateRegistry">
  <div class="prepaidPacketBoxContainer">
    <div class="prepaidPacketBox">
      <style type="text/css">
        .fusion-accordian #accordion-tender-packet .panel-title a .fa-fusion-box {
          color: #ffffff;
        }

        .fusion-accordian #accordion-tender-packet .panel-title a .fa-fusion-box:before {
          font-size: 16px;
          width: 16px;
        }
      </style>
      <div class="accordian fusion-accordian" style="margin-bottom: 5%">
        <div class="panel-group" id="accordion-tender-packet" role="tablist">
          <div class="fusion-panel panel-default fusion-toggle-no-divider" role="tabpanel">
            <div class="panel-heading">
              <div>
                <h4 class="panel-title toggle">
                  <a aria-expanded="false" aria-selected="false" aria-controls="#tender-packet" role="tab"
                    data-toggle="collapse" data-parent="#accordion-tender-packet" data-target="#tender-packet"
                    href="#tender-packet"><span class="fusion-toggle-icon-wrapper" aria-hidden="true"><i
                        class="fa-fusion-box"></i></span><span class="fusion-toggle-heading"
                      style="font-weight: 600; color: #333333">ABBONAMENTO GARE</span></a>
                </h4>
              </div>
              <div id="tender-packet" class="panel-collapse collapse">
                <style>
                  ol.letter,
                  ol.number {
                    counter-reset: list;
                    margin: 10px 0 10px 0;
                  }

                  ol.letter>li,
                  ol.number>li {
                    list-style: none;
                    font-size: 15px;
                    color: #333333;
                    font-weight: 400;
                    margin-top: 10px;
                  }

                  ol.letter>li:before {
                    counter-increment: list;
                    content: counter(list, lower-alpha) ") ";
                  }

                  ol.number>li:before {
                    content: counter(list) ") ";
                    counter-increment: list;
                  }

                  span.column-name {
                    border: 1px solid #333333;
                    margin-right: 5px;
                    padding: 0 2px;
                    font-size: 14px;
                  }
                </style>
                <div class="panel-body toggle-content fusion-clearfix">
                  <h5>
                    Questo abbonamento ti permette di acquistare gare ad un prezzo
                    vantaggioso, anziché pagare ogni singola gara al suo prezzo
                    originale.
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h5 *ngIf="profile.prepaidCredits.amount">
        ABBONAMENTO DI {{ profile.prepaidCredits.amount }} GARE ACQUISTATO IN DATA
        {{ profile.prepaidCredits.purchaseDate }} &#8211; (<strong>SCAD. {{ profile.prepaidCredits.expirationDate
          }}</strong>)
      </h5>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
      <h3 *ngIf="profile.prepaidCredits.amount" style="text-align: center">
        {{ profile.prepaidCredits.remaining }}
        {{
        profile.prepaidCredits.remaining === 1
        ? "GARA RESIDUA"
        : "GARE RESIDUE"
        }}
      </h3>
      <h3 *ngIf="profile.prepaidCredits.amount === null" style="text-align: center">
        Nessun acquisto effettuato
      </h3>
      <div *ngIf="!profile.prepaidCredits.professionalRegistrySubscriber" class="fusion-sep-clear"></div>
      <div *ngIf="!profile.prepaidCredits.professionalRegistrySubscriber"
        class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
      <h5 *ngIf="!profile.prepaidCredits.professionalRegistrySubscriber">
        Completa il tuo
        <a (click)="goToProfile()" target="_self" style="cursor: pointer">profilo</a>
        con il numero di iscrizione all'albo per ottenere degli sconti.
      </h5>
      <h5 *ngIf="creditExpired" style="margin-top: 4vh">
        Acquista un nuovo abbonamento per rendere di nuovo utilizzabili i crediti
        scaduti.
      </h5>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div class="fusion-layout-column fusion_builder_column"
          style="margin-top: 0px; margin-bottom: 0px; width: 100%">
          <div class="fusion-column-wrapper fusion-column-wrapper-43" style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            " data-bg-url="">
            <div style="font-size: 12px; color: black">
              UTILIZZATO da:<br />
              - Professionisti o Committenti per CREARE gare d’appalto<br />
              - Imprese per CREARE gare di subappalto<br /><br />
            </div>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-37 {
                  border-radius: 0px;
                }
              </style><a (click)="buyTenderPrepaidPacket()" class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-37
                  fusion-button-span-yes fusion-button-default-type
                " target="_self"><span class="fusion-button-text">ACQUISTA ABBONAMENTO</span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="prepaidPacketBox">
      <style type="text/css">
        .fusion-accordian #accordion-participation-packet .panel-title a .fa-fusion-box {
          color: #ffffff;
        }

        .fusion-accordian #accordion-participation-packet .panel-title a .fa-fusion-box:before {
          font-size: 16px;
          width: 16px;
        }
      </style>
      <div class="accordian fusion-accordian" style="margin-bottom: 5%">
        <div class="panel-group" id="accordion-participation-packet" role="tablist">
          <div class="fusion-panel panel-default fusion-toggle-no-divider" role="tabpanel">
            <div class="panel-heading">
              <div>
                <h4 class="panel-title toggle">
                  <a aria-expanded="false" aria-selected="false" aria-controls="#participation-packet" role="tab"
                    data-toggle="collapse" data-parent="#accordion-participation-packet"
                    data-target="#participation-packet" href="#participation-packet"><span
                      class="fusion-toggle-icon-wrapper" aria-hidden="true"><i class="fa-fusion-box"></i></span><span
                      class="fusion-toggle-heading" style="font-weight: 600; color: #333333">ABBONAMENTO
                      PARTECIPAZIONI</span></a>
                </h4>
              </div>
              <div id="participation-packet" class="panel-collapse collapse">
                <style>
                  ol.letter,
                  ol.number {
                    counter-reset: list;
                    margin: 10px 0 10px 0;
                  }

                  ol.letter>li,
                  ol.number>li {
                    list-style: none;
                    font-size: 15px;
                    color: #333333;
                    font-weight: 400;
                    margin-top: 10px;
                  }

                  ol.letter>li:before {
                    counter-increment: list;
                    content: counter(list, lower-alpha) ") ";
                  }

                  ol.number>li:before {
                    content: counter(list) ") ";
                    counter-increment: list;
                  }

                  span.column-name {
                    border: 1px solid #333333;
                    margin-right: 5px;
                    padding: 0 2px;
                    font-size: 14px;
                  }
                </style>
                <div class="panel-body toggle-content fusion-clearfix">
                  <h5>
                    Acquistando questo abbonamento potrai partecipare alle gare ad
                    un prezzo vantaggioso, anziché pagare per partecipare ad
                    ogni singola gara il prezzo originale.
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h5 *ngIf="profile.participationPrepaidCredits.amount">
        ABBONAMENTO DI
        {{ profile.participationPrepaidCredits.amount }} PARTECIPAZIONI
        ACQUISTATO IN DATA
        {{ profile.participationPrepaidCredits.purchaseDate }} &#8211; (<strong>SCAD.
          {{ profile.participationPrepaidCredits.expirationDate }}</strong>)
      </h5>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
      <h3 *ngIf="profile.participationPrepaidCredits.amount" style="text-align: center">
        {{ profile.participationPrepaidCredits.remaining }}
        {{
        profile.participationPrepaidCredits.remaining === 1
        ? "PARTECIPAZIONE RESIDUA"
        : "PARTECIPAZIONI RESIDUE"
        }}
      </h3>
      <h3 *ngIf="profile.participationPrepaidCredits.amount === null" style="text-align: center">
        Nessun acquisto effettuato
      </h3>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
      <h5 *ngIf="participationCreditExpired" style="margin-top: 4vh">
        Acquista un nuovo abbonamento per rendere di nuovo utilizzabili i crediti
        scaduti.
      </h5>
      <div class="fusion-sep-clear"></div>
      <div class="fusion-separator fusion-full-width-sep sep-none"
        style="margin-left: auto; margin-right: auto; margin-top: 50px"></div>
      <div class="fusion-builder-row fusion-builder-row-inner fusion-row">
        <div class="fusion-layout-column fusion_builder_column"
          style="margin-top: 0px; margin-bottom: 0px; width: 100%">
          <div class="fusion-column-wrapper fusion-column-wrapper-43" style="
              padding: 0px 0px 0px 0px;
              background-position: left top;
              background-repeat: no-repeat;
              -webkit-background-size: cover;
              -moz-background-size: cover;
              -o-background-size: cover;
              background-size: cover;
            " data-bg-url="">
            <div style="font-size: 12px; color: black">
              UTILIZZATO da:<br />
              - Imprese per PARTECIPARE alle gare d’appalto<br /><br />
            </div>
            <div class="fusion-button-wrapper fusion-align-block">
              <style type="text/css">
                .fusion-button.button-37 {
                  border-radius: 0px;
                }
              </style><a (click)="buyParticipationPrepaidPacket()" class="
                  fusion-button
                  button-flat
                  fusion-button-default-size
                  button-default button-37
                  fusion-button-span-yes fusion-button-default-type
                " target="_self"><span class="fusion-button-text">ACQUISTA ABBONAMENTO</span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fusion-layout-column fusion_builder_column"
    style="margin-top: 3%; margin-bottom: 0px; width: 100%; text-align: center">
    <div class="fusion-column-wrapper fusion-column-wrapper-42" style="
        padding: 0px 0px 0px 0px;
        background-position: left top;
        background-repeat: no-repeat;
        -webkit-background-size: cover;
        -moz-background-size: cover;
        -o-background-size: cover;
        background-size: cover;
      " data-bg-url="">
      <div class="fusion-button-wrapper fusion-align-block">
        <style type="text/css">
          .fusion-button.button-36 {
            border-radius: 0px;
          }
        </style>
        <a [routerLink]="['/creaunagara']" style="width: 30%" class="
            fusion-button
            button-flat
            fusion-button-default-size
            button-default button-36
            fusion-button-span-yes fusion-button-default-type
          " target="_self"><span class="fusion-button-text">CREA GARA</span></a>
      </div>
    </div>
  </div>
</div>